import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { DisclosureDataModel } from './disclosure.model';

export class DisclosureConfiguration extends ReportSectionConfigurationBase {
  typeName = 'DisclosureConfiguration';
  nodataLocalizationKeyName = 'bnyDepositoryDisclosure';
  readonly reportSection = ReportSection.Disclosure;
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_Disclosure];
  maxSize = 4;
  defaultSize = 4;
  minSize = 0;
  override disabledLayoutWidthControl = true;
  override disableSectionSelection = true;
  name = 'disclosure';
  displayName = 'Disclosure';
  canConfigure = true;
  order = 15;
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface DisclosureComponentData {
  [ReportViewModelSection.BnyManagementReport_Disclosure]: {
    disclosureDataModel: DisclosureDataModel;
  };
}
